import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: [],
  errorMsg: "",
  currentPostId: "",
  activeImageId: "",
  mediaType: "video",
  activeTemplateId: "",
  editOpen: false,
  previewOpen: false,
  multiDeleteActive: false,
  multipleDeleteIds: [],
  templateIdsArr: [],
};

const setPostLoading = (state, action) => {
  state.loading = action.payload;
};
const setPostError = (state, action) => {
  state.loading = false;
  state.errorMsg = action.payload;
};
const setTemplateIdsArr = (state, action) => {
  state.loading = true;
  state.templateIdsArr = action.payload;
};
const setPostData = (state, action) => {
  state.loading = false;
  if (
    action.mode === "new" ||
    action.mode === "quick" ||
    action.mode === "filter"
  ) {
    state.data = action.payload;
  } else if (action.mode === "add_rev") {
    state.data = [...action.payload, ...state.data];
  } else {
    state.data = [...state.data, ...action.payload];
  }
  state.errorMsg = "";
};

const deletePost = (state, action) => {
  if (typeof action.payload === "string") {
    state.data = state.data.filter((p) => p.event_id !== action.payload);
  } else if (typeof action.payload === "object") {
    state.data = state.data.filter(
      (p) => action.payload.indexOf(p.event_id) === -1
    );
    state.multipleDeleteIds = [];
  }
};
const setActiveTemplateId = (state, action) => {
  state.activeTemplateId = action.payload;
};
const setMediaType = (state, action) => {
  state.mediaType = action.payload;
};
const setCurrentPostId = (state, action) => {
  state.currentPostId = action.payload;
};
const setActiveImageId = (state, action) => {
  state.activeImageId = action.payload;
};
const setEditOpen = (state) => {
  state.editOpen = !state.editOpen;
};
const setPreviewOpen = (state) => {
  state.previewOpen = !state.previewOpen;
};
const setDeleteMultipleActive = (state, action) => {
  state.multiDeleteActive = action.payload;
};

const setMultipleDeletePosts = (state, action) => {
  if (action.mode === "add") {
    state.multipleDeleteIds = [...state.multipleDeleteIds, action.payload];
    // state.multipleDeleteIds = [action.payload];
  } else if (action.mode === "reset") {
    state.multipleDeleteIds = [];
  } else {
    state.multipleDeleteIds = state.multipleDeleteIds.filter(
      (p) => p !== action.payload
    );
  }
};

const updatePostData = (state, action) => {
  const payload = action.payload;
  state.data.find((p) => p.event_id === payload.postId)[payload.key] =
    payload.data;
};
const updateCreativeDetails = (state, action) => {
  if (action.mode === "carousel") {
    // Find the post from event id, then navigate to pages and map over them changing the url to the corresponding array's index from payload
    state.data
      .find((el) => el.event_id === action.event_id)
      ["creative_details"][0].pages.map((el, i) => {
        return (el.url = action.payload[i]);
      });
  } else if (action.mode === "video") {
    state.data.find((el) => el.event_id === action.event_id)[
      "creative_details"
    ][0].thumb_url = action.thumb_url;
    state.data.find((el) => el.event_id === action.event_id)[
      "creative_details"
    ][0].url = action.payload;
  } else {
    state.data.find((el) => el.event_id === action.event_id)[
      "creative_details"
    ][0].url = action.payload;
  }
};
const resetTempId = (state) => {
  state.templateIdsArr = [];
};
const getPostsSlice = createSlice({
  name: "getPosts",
  initialState,
  reducers: {
    setPostLoading,
    setPostError,
    setActiveTemplateId,
    setPostData,
    setCurrentPostId,
    setActiveImageId,
    setMediaType,
    setEditOpen,
    setPreviewOpen,
    deletePost,
    setDeleteMultipleActive,
    setMultipleDeletePosts,
    updatePostData,
    setTemplateIdsArr,
    resetTempId,
    updateCreativeDetails,
  },
});

export default getPostsSlice.reducer;
